import { createAsyncThunk } from "@reduxjs/toolkit";
import authApi from "../../authApi";
import {
  setadvanceSearchResource,
  setEditInternalResource,
  setInternalResource,
  setProfileNumber,
  setResourcePositionList,
  setResourceStatusList,
  setSearchExternalResource,
  setSingleInternalResource,
  setTreeMenueList,
} from "../../Slice/internalModule/internalResourceSlice";
import { showSnackbar } from "../../Slice/snackbar/snackbarSlice";
import { setLoading } from "../../Slice/loading/loadingSlice";

export const getInternalResourceList = createAsyncThunk(
  "getInternalResourceList/list",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/getResources`,request);
      if (response?.status === 200) {
        dispatch(setInternalResource(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const getSingleInternalResource = createAsyncThunk(
  "getSingleInternalResource",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/viewExternalget/${request}`);
      if (response?.status === 200) {
        dispatch(setSingleInternalResource(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const activationRemider = createAsyncThunk(
  "activationRemider",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/sendAcountActivationlink`, request);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: "Remider activated successfully",
            type: "info",
          })
        );
      }
    } catch (error) {
      console.log("error: ", error);
    }
  }
);

export const getProfileNumber = createAsyncThunk(
  "getProfileNumber",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/userProfileNumber/${request.id}`);
      if (response?.status === 200) {
        dispatch(setProfileNumber(response?.data));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  }
);
export const getResourceStatusOptions = createAsyncThunk(
  "getResourceStatusOption",
  async (_, { dispatch }) => {
    try {
      const response = await authApi.get(`/userstatusactive`);
      if (response?.status === 200) {
        const options = response?.data?.map((item) => {
          return { value: item?.status_id, label: item?.status_name };
        });
        dispatch(setResourceStatusList(options));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  }
);

// getTreeMenu
export const getTreeMenueOptions = createAsyncThunk(
  "getTreeMenueOptions",
  async (_, { dispatch }) => {
    try {
      const response = await authApi.get(`/getTreeMenu`);
      if (response?.status === 200) {
        const options = Object.values(response?.data).map((item) => ({
          value: item?.id,
          label: item?.name,
        }));

        dispatch(setTreeMenueList(options));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  }
);

export const getResourcePosition = createAsyncThunk(
  "getResourcePosition",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/select2GetAll/${request?.id}`);
      if (response?.status === 200) {
        const options = response?.data?.data?.map((item) => {
          return { value: item?.position_id, label: item?.position_name };
        });
        dispatch(setResourcePositionList(options));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  }
);


export const SaveUserProfileInternal = createAsyncThunk(
  "saveuserprofileinternal",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/saveuserprofileinternal`, request);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg || "Successfully Inserted",
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      )
      console.log("error: ", error);
    }
  }
);

export const UpdateSaveUserProfileInternal = createAsyncThunk(
  "saveuserprofileinternal",
  async (request, { dispatch, rejectWithValue }) => {

    try {
      const response = await authApi.put(`/saveuserprofileinternal/${request?.iUserId}`, request);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg || "Successfully Inserted",
            type: "success",
          })
        );
        return response?.data;
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      )
      console.log("error: ", error);
      return rejectWithValue(error?.response?.data || { msg: "Profile update failed." });
    }
  }
);
export const DeleteUserProfileInternal = createAsyncThunk(
  "deleteUser",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.delete(`/deleteUser/${request?.id}`);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg || "Successfully Inserted",
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      )
      console.log("error: ", error);
    }
  }
);


/** @deprecated Use /absences APIs via AbsenceManager or Holiday Planner thunks. */
export const UpdateAbsent = createAsyncThunk(
  "updateAbscentDate",
  async (request, { dispatch }) => {
    try {
      const { user_id, ...payload } = request;
      const response = await authApi.put(`/updateAbscentDate/${user_id}`, payload);
      if (response?.status === 200) {
        // dispatch(getSingleInternalResource(user_id));
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      )
      console.log("error: ", error);
    }
  }
);
export const changeUserStatus = createAsyncThunk(
  "changeUserStatus",
  async (request, { dispatch }) => {
    try {
      const { id, ...payload } = request;
      const response = await authApi.put(`/changeUserStatus/${id}`, payload);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            status: response?.data?.status,
            type: "success",
          })
        );
      }
      return response.data;
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.log("error: ", error);
    }
  }
);

export const getsearchExternalResource = createAsyncThunk(
  "resourceSearch",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/resourceSearch`, request);
      if (response?.status === 200) {

        dispatch(setSearchExternalResource(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getadvanceSearchResource = createAsyncThunk(
  "advanceSearchResource",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.post(`/advanceSearchResource`, request);
      if (response?.status === 200) {

        dispatch(setadvanceSearchResource(response?.data));
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const editInternalResource = createAsyncThunk(
  "getProfile",
  async (request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await authApi.get(`/getProfile/${request}`);
      if (response?.status === 200) {
        dispatch(setEditInternalResource(response?.data));
        setLoading(false);
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      )
      console.log("error: ", error);
    }finally {
      dispatch(setLoading(false));
    }
  }
);